const yup = require("yup");

const transactionPolicies = yup.object().shape({
  transactionsAmount: yup.number().required("Transactions amount is required"),
});

export default transactionPolicies;
